module.exports = __webpack_public_path__ + "static/media/breakfast1.c0c0e4c8.png";